import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field, CccisdInput, CccisdToggle } from 'cccisd-formik';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import Loader from 'cccisd-loader';
import Cross from 'cccisd-icons/cross3';
import style from './style.css';
import { startsWith } from 'lodash';
import HiddenBlock from 'cccisd-hidden-block';

const Boilerplate = window.cccisd.boilerplate;

export default class ContainerSearch extends React.Component {
    static propTypes = {
        closeModal: PropTypes.func,
    };

    modal = React.createRef();

    state = {
        loading: true,
    };

    componentDidMount = async () => {
        this.setState({
            loading: false,
        });
    };

    getInitialValues = () => {
        const initialValues = {
            search_string: '',
            search_path: './*',
            search_bundles: false,
            search_qa: true,
            search_staging: false,
            search_prod: false,
        };

        return initialValues;
    };

    // Prevent loss of unsaved changes
    confirmClose = () => {
        this.props.closeModal();
    };

    onSubmit = async (values, actions) => {
        this.setState({
            loading: true,
        });

        let formattedData = values;

        const response = await axios
            .post(Boilerplate.route('api.monitoring.devops.job.container-search'), { ...formattedData })
            .catch(() => {
                this.setState({ loading: false });
            });

        this.setState({
            loading: false,
        });

        if (!response || response.data.status !== 'success') {
            notification({ message: 'An error occured', type: 'danger' });
        }

        this.props.closeModal();
    };

    validate = values => {
        const errors = {};

        if (!('search_string' in values) || !values.search_string) {
            errors.search_string = 'Search string is required';
        }
        if ('search_path' in values && values.search_path && !startsWith(values.search_path, './')) {
            errors.search_path = 'Search Path must start with ./';
        }
        if ('search_path' in values && !values.search_path) {
            errors.search_path = 'Search Path is required';
        }

        return errors;
    };

    render() {
        const { loading } = this.state;

        if (loading) {
            return <Loader loading />;
        }

        return (
            <>
                <div className={style.replaceClose}>
                    <button className="close" type="button" onClick={this.confirmClose}>
                        <Cross />
                    </button>
                </div>
                <Formik
                    initialValues={this.getInitialValues()}
                    validate={this.validate}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={this.onSubmit}
                    render={({ values, errors }) => {
                        return (
                            <Form>
                                <div style={{ minHeight: '270px' }}>
                                    <Field
                                        name="search_string"
                                        label="String to search for in deployed containers"
                                        component={CccisdInput}
                                    />
                                    <Field name="search_qa" label="Search QA environment" component={CccisdToggle} />
                                    <Field
                                        name="search_staging"
                                        label="Search Staging environment"
                                        component={CccisdToggle}
                                    />
                                    <Field
                                        name="search_prod"
                                        label="Search Prod environment"
                                        component={CccisdToggle}
                                    />
                                    <div style={{ marginTop: '50px', marginBottom: '50px' }}>
                                        <HiddenBlock title="Optional settings">
                                            <Field
                                                name="search_path"
                                                label="Path to search within deployed containers (example: ./resources/assets/js)"
                                                component={CccisdInput}
                                                placeholder="./*"
                                            />
                                            <Field
                                                name="search_bundles"
                                                label="Search CSS & JS bundle files"
                                                component={CccisdToggle}
                                            />
                                        </HiddenBlock>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginTop: '1em',
                                    }}
                                >
                                    <button className="btn btn-primary" type="button" onClick={this.confirmClose}>
                                        Cancel
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        style={{
                                            backgroundColor: '#F0AD4E',
                                            borderColor: '#fff',
                                        }}
                                    >
                                        Search
                                    </button>
                                </div>
                            </Form>
                        );
                    }}
                />
            </>
        );
    }
}
